import * as React from 'react';
// import { prevent } from 'common/prevent';
import { VSpacer } from 'naan/primitives/spacer';
import { styled } from 'naan/stitches.config';
import { InteractiveTag, TagsContainer } from 'naan/primitives/tags';
import { Text } from 'naan/primitives/text';
import { AnimatedTagsContainer } from './animated-tags-container';
import { FilterBox } from './filter-box';
import { AppFactory } from '@app/app-factory';

const ThemesFilterPanelWrapper = styled('div', {
  maxWidth: '960px',
  margin: '0 auto',
});

export const ThemesFilterPanel = ({ show = false }: { show: boolean }) => {
  const { storyManager } = AppFactory.root;

  return (
    <AnimatedTagsContainer show={show}>
      <ThemesFilterPanelWrapper>
        <VSpacer size={2} />
        <Text textStyle="tiny-text" color={'textSecondary'}>
          AP THEMES
        </Text>
        <VSpacer size={2} />
        <TagsContainer>
          <FilterBox
            filterItems={storyManager.apTagsList}
            filterQueryKey={'themes'}
            renderFilterControl={(item, selected, action) => {
              return (
                <InteractiveTag
                  role="button"
                  selected={selected}
                  onSelect={action}
                  type="topic"
                >
                  {item}
                </InteractiveTag>
              );
            }}
          />
        </TagsContainer>
        <VSpacer size={4} />
        <Text textStyle="tiny-text" color={'textSecondary'}>
          IB THEMES
        </Text>
        <VSpacer size={2} />
        <TagsContainer>
          <FilterBox
            filterItems={storyManager.ibTagsList}
            filterQueryKey={'themes'}
            renderFilterControl={(item, selected, action) => {
              return (
                <InteractiveTag
                  role="button"
                  selected={selected}
                  onSelect={action}
                  type="topic"
                >
                  {item}
                </InteractiveTag>
              );
            }}
          />
        </TagsContainer>
      </ThemesFilterPanelWrapper>
    </AnimatedTagsContainer>
  );
};
